import {
  AwsIntegrationPage,
  AwsIntegrationPageProps,
} from "~/pages/integrations/aws/AwsIntegrationPage";

const AwsIntegrationEntryPage = ({ scope }: AwsIntegrationPageProps) => {
  return <AwsIntegrationPage {...{ scope }} />;
};

export default AwsIntegrationEntryPage;
